import React, { useEffect, useState } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Card,
  CardBody,
  Label,
  Input,
  Col,
  Container,
  Row,
  Badge,
  Form,
  FormFeedback,
} from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import Select from "react-select";
import CRUDService from "../API_RELATED/CRUDService";
import toast from "react-hot-toast";

const GeneralCrudModal = ({ isOpen, toggle, editUserData, setLoading,setEditUserData, isEdit }) => {
  const [roles, setRoles] = useState([]);

  // Fetch roles from the API and transform them into react-select format
  const fetchRoles = async () => {
    try {
      const response = await CRUDService.getRoles();
      // Transform API response into { value, label } format
      const roleOptions = response.map((role) => ({
        value: role.name,
        label: role.normalizedName,
      }));
      setRoles(roleOptions);
    } catch (error) {
      console.error("Error fetching roles:", error);
    }
  };

  useEffect(() => {
    fetchRoles();
  }, []);

  console.log(editUserData)

  const validation = useFormik({
    
    enableReinitialize: isEdit, 
    initialValues: {
      email: editUserData?.email || "",
      username: editUserData?.username || "",
      firstName: editUserData?.firstName || "",
      lastName: editUserData?.lastName || "",
      roles: editUserData?.roles
        ? editUserData?.roles?.map((r) => ({ value: r, label: r.toUpperCase() })) // Adjust label as needed
        : [],
      password: "",
      ...(editUserData.email ? {} : { confirmPassword: "" }),
      address: editUserData?.address || "",
      phoneNumber: editUserData?.phoneNumber || "",
    },

    // initialValues: {
    //   email: "",
    //   username: "",
    //   firstName: "",
    //   lastName: "",
    //   roles: [],
    //   password: "",
    
    //   address: "",
    //   phoneNumber:  "",
    // }, 


    validationSchema: Yup.object({
      email: Yup.string()
        .matches(
          /^[a-zA-Z0-9._%+-]+@(gmail\.com|yahoo\.com|outlook\.com)$/,
          "Only Gmail, Yahoo, and Outlook emails are allowed"
        )
        .required("Please Enter Your Email"),
      // username: Yup.string().required("Please Enter Your Username"),
      username: Yup.string()
        .email("Please enter in email format")
        .required("Please Enter Your Username"),

      firstName: Yup.string().required("Please Enter Your First Name"),
      lastName: Yup.string().required("Please Enter Your Last Name"),
      roles: Yup.array()
        .min(1, "Please select at least one role")
        .required("Role is required"),
      address: Yup.string().required("Address is required"),
      phoneNumber: Yup.string()
        .required("Phone number is required")
        .matches(/^[0-9]{10}$/, "Phone number must be exactly 10 digits"),
      password: Yup.string()
        .min(6, "Password must be at least 6 characters")
        .required("Please Enter Your Password"),
      ...(editUserData.email
        ? {}
        : {
            confirmPassword: Yup.string()
              .required("Please confirm your password")
              .oneOf([Yup.ref("password"), null], "Passwords must match"),
          }),
    }),

    onSubmit: async (values, { setSubmitting, resetForm }) => {
      const finalValues = {
        ...values,
        isAdmin: true,
        isApproved: true,
        roles: values.roles.map((e) => e.value),
        phoneNumber: `${values.phoneNumber}`,
      };

      try {
        const res = isEdit
          ? await CRUDService.update(editUserData.id, finalValues)
          : await CRUDService.create(finalValues);

        toast.success(
          `Data ${isEdit ? "updated" : "created"} successfully`
        );
        setLoading(true);
        toggle();
        resetForm();
   
      } catch (error) {
        console.error("Error:", error);
        toast.error(
          error.response?.data ||
            `Error occurred while ${
              editUserData.email ? "updating" : "creating"
            }`
        );
      } finally {
        setSubmitting(false);
      }
    },
  });

  const handleCancel = () => {
    validation.resetForm();
    toggle();
  };

  return (
    <Modal isOpen={isOpen} toggle={handleCancel}>
      <ModalHeader toggle={handleCancel}>
        {isEdit ? "Edit User" : "Add New User"}
      </ModalHeader>
      <ModalBody>
        <Container fluid>
          <Form onSubmit={validation.handleSubmit} className="w-100">
            <div className="mb-3">
              <Label htmlFor="username">Username</Label>
              <Input
                name="username"
                className="form-control"
                placeholder="Enter username"
                type="text"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                value={validation.values.username}
                invalid={
                  validation.touched.username && !!validation.errors.username
                }
              />
              <FormFeedback>{validation.errors.username}</FormFeedback>
            </div>

            <Row className="mb-3">
              <Col>
                <Label htmlFor="firstName">First Name</Label>
                <Input
                  name="firstName"
                  className="form-control"
                  placeholder="Enter First Name"
                  type="text"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.firstName}
                  invalid={
                    validation.touched.firstName &&
                    !!validation.errors.firstName
                  }
                />
                <FormFeedback>{validation.errors.firstName}</FormFeedback>
              </Col>
              <Col>
                <Label htmlFor="lastName">Last Name</Label>
                <Input
                  name="lastName"
                  className="form-control"
                  placeholder="Enter Last Name"
                  type="text"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.lastName}
                  invalid={
                    validation.touched.lastName && !!validation.errors.lastName
                  }
                />
                <FormFeedback>{validation.errors.lastName}</FormFeedback>
              </Col>
            </Row>

            <Row className="mb-3">
              <Col>
                <Label htmlFor="email">Email</Label>
                <Input
                  name="email"
                  className="form-control"
                  placeholder="Enter email"
                  type="email"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.email}
                  invalid={
                    validation.touched.email && !!validation.errors.email
                  }
                />
                <FormFeedback>{validation.errors.email}</FormFeedback>
              </Col>
              <Col>
                <Label htmlFor="phoneNumber">Phone Number</Label>
                <Input
                  name="phoneNumber"
                  className="form-control"
                  placeholder="Enter phone number"
                  type="text"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.phoneNumber}
                  invalid={
                    validation.touched.phoneNumber &&
                    !!validation.errors.phoneNumber
                  }
                />
                <FormFeedback>{validation.errors.phoneNumber}</FormFeedback>
              </Col>
            </Row>

            <div className="mb-3">
              <Label>Roles</Label>
              <Select
                value={validation.values.roles}
                isMulti={true}
                onChange={(selectedOptions) =>
                  validation.setFieldValue("roles", selectedOptions || [])
                }
                onBlur={() => validation.setFieldTouched("roles", true)}
                options={roles} // Use dynamic roles from state
                name="roles"
              />
              {validation.touched.roles && validation.errors.roles && (
                <div
                  className="text-danger mt-1"
                  style={{ fontSize: "0.875em" }}
                >
                  {validation.errors.roles}
                </div>
              )}
            </div>

            <div className="mb-3">
              <Label htmlFor="address">Address</Label>
              <Input
                type="textarea"
                name="address"
                className="form-control"
                value={validation.values.address}
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                invalid={
                  validation.touched.address && !!validation.errors.address
                }
              />
              <FormFeedback>{validation.errors.address}</FormFeedback>
            </div>

            <Row className="mb-3">
              <Col>
                <Label htmlFor="password">Password</Label>
                <Input
                  name="password"
                  value={validation.values.password}
                  type="password"
                  className="form-control"
                  placeholder="Enter Password"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  invalid={
                    validation.touched.password && !!validation.errors.password
                  }
                />
                <FormFeedback>{validation.errors.password}</FormFeedback>
              </Col>
              {!editUserData.email && (
                <Col>
                  <Label htmlFor="confirmPassword">Confirm Password</Label>
                  <Input
                    name="confirmPassword"
                    value={validation.values.confirmPassword}
                    type="password"
                    className="form-control"
                    placeholder="Confirm Password"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    invalid={
                      validation.touched.confirmPassword &&
                      !!validation.errors.confirmPassword
                    }
                  />
                  <FormFeedback>
                    {validation.errors.confirmPassword}
                  </FormFeedback>
                </Col>
              )}
            </Row>
            <div className="d-flex justify-content-end gap-2">
              <Button
                color="danger"
                onClick={handleCancel}
                disabled={validation.isSubmitting}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                color="success"
                disabled={validation.isSubmitting}
              >
                {validation.isSubmitting ? "Submitting..." : "Submit"}
              </Button>
            </div>
          </Form>
        </Container>
      </ModalBody>
    </Modal>
  );
};

export default GeneralCrudModal;
